import {getCookie, setCookie} from "@insite/client-framework/Common/Cookies";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import EmailSubscriptionSignUpModal from "@preferredMedical/Widgets/Header/EmailSubscriptionSignUpModal"
import React from "react";

const enum fields {
    emailRecipients = "emailRecipients",
    classesOfTrade = "classesOfTrade",
    title = "title",
    description = "description"
}

type Props = WidgetProps;

const emailSubscriptionSignUpCookieName = "ShowEmailSubscriptionSignUpModal"

const EmailSubscriptionSignUpWidget: React.FC<Props> = ({ fields }) => {
    const emailSubscriptionSignUpCookie = getCookie(emailSubscriptionSignUpCookieName);

    if(emailSubscriptionSignUpCookie)
        {return null;}
        
    setCookie(emailSubscriptionSignUpCookieName, "false", {expires: 365});

    return (
        <EmailSubscriptionSignUpModal
                emailRecipients={fields.emailRecipients}
                classesOfTrade={fields.classesOfTrade}
                title={fields.title}
                description={fields.description}
        />
    );
};

const widgetModule: WidgetModule = {
    component: EmailSubscriptionSignUpWidget,
    definition: {
        displayName: "Email Subscription Sign Up",
        group: "Header",
        fieldDefinitions: [
            {
                name: fields.emailRecipients,
                displayName: "Email recipients (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true
            },
            {
                name: fields.classesOfTrade,
                displayName: "Classes of Trade (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true
            },
            {
                name: fields.title,
                displayName: "Email Subscription Sign Up Modal Title",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "Good Things Happen",
                isRequired: true,
            },
            {
                name: fields.description,
                displayName: "Email Subscription Sign Up Modal Description",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "Our email subscribers get the inside scoop on new products, promotions, news, and more. Sign up, you'll thank us later.",
                isRequired: true,
            },
        ]
    },
};

export default widgetModule;